let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2zh8u")).then(() => parcelRequire('4BVSW'));